var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3032 28.7312H14.2406C6.41263 28.7312 0.0439453 22.3625 0.0439453 14.5346V14.472C0.0439453 6.64407 6.41263 0.275391 14.2406 0.275391H14.3032C22.1311 0.275391 28.4998 6.64407 28.4998 14.472V14.5346C28.4998 22.3625 22.1311 28.7312 14.3032 28.7312ZM14.2406 1.23859C6.94336 1.23859 1.00715 7.17479 1.00715 14.472V14.5346C1.00715 21.8318 6.94336 27.768 14.2406 27.768H14.3032C21.6004 27.768 27.5366 21.8318 27.5366 14.5346V14.472C27.5366 7.17479 21.6004 1.23859 14.3032 1.23859H14.2406Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.526 6.35034H10.019C7.66879 6.35034 5.75684 8.2623 5.75684 10.6125V18.3952C5.75684 20.7454 7.66879 22.6573 10.019 22.6573H18.526C20.8762 22.6573 22.7882 20.7454 22.7882 18.3952V10.6125C22.7882 8.2623 20.8762 6.35034 18.526 6.35034ZM7.26039 10.6125C7.26039 9.09161 8.49811 7.85391 10.019 7.85391H18.526C20.0469 7.85391 21.2846 9.09161 21.2846 10.6125V18.3952C21.2846 19.9161 20.0469 21.1538 18.526 21.1538H10.019C8.49811 21.1538 7.26039 19.9161 7.26039 18.3952V10.6125Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.2722 18.4674C16.4577 18.4674 18.2367 16.6893 18.2367 14.5029C18.2367 12.3164 16.4586 10.5383 14.2722 10.5383C12.0857 10.5383 10.3076 12.3164 10.3076 14.5029C10.3076 16.6893 12.0857 18.4674 14.2722 18.4674ZM14.2722 12.0429C15.6293 12.0429 16.7331 13.1467 16.7331 14.5038C16.7331 15.861 15.6293 16.9648 14.2722 16.9648C12.915 16.9648 11.8112 15.861 11.8112 14.5038C11.8112 13.1467 12.915 12.0429 14.2722 12.0429Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.6038 11.1789C19.1923 11.1789 19.672 10.7002 19.672 10.1107C19.672 9.5212 19.1933 9.04248 18.6038 9.04248C18.0144 9.04248 17.5356 9.5212 17.5356 10.1107C17.5356 10.7002 18.0144 11.1789 18.6038 11.1789Z",
    fill: "#404040"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterInstagram);
export default __webpack_public_path__ + "static/media/footer-Instagram.792ef54f23e95b3cba4317f02935c0d6.svg";
export { ForwardRef as ReactComponent };